module.exports = __webpack_public_path__ + "static/media/cyberalpaca-logo.60f51a65.svg";